import { render } from "./Viewer.vue?vue&type=template&id=026ef4f1&scoped=true&ts=true"
import script from "./Viewer.vue?vue&type=script&lang=ts"
export * from "./Viewer.vue?vue&type=script&lang=ts"

import "./Viewer.vue?vue&type=style&index=0&id=026ef4f1&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026ef4f1"]])

export default __exports__